import { NavLink } from "react-router";

import $ from "jquery";

import appAjax from "../helpers/ajax";
import appUi from "../helpers/ui";
import { useEffect, useState } from "react";

import { KEY_ACCESS_TOKEN } from '../modals/login';

function About() {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSessions, setIsLoadingSessions] = useState(false);
  const [userData, setUserData] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [listSessions, setListSessions] = useState([]);

  var isInit = false;

  const loadUserSessions = () => {
    appAjax._ajax_send(null, {
        type: 'GET',
        beforeSend: function() {
            setIsLoadingSessions(true);
        },
        success: function(response) {
            setListSessions(response.data);
        },
        error: function(response) {
            setErrorMessage(response.message);
        },
        always: function() {
            setIsLoadingSessions(false);
        }
    }, 'Loading user sessions...', appAjax.apiBaseUrl + '/my/sessions');
  };

  const onClickSendMessage = (e) => {
    var elRow = $(e.target).closest('tr');
    var valUuid = $(elRow).data('record-uuid');

    //-- Disable button
    appAjax._ajax_send({
      session_uuid: valUuid,
    }, {
        type: 'POST',
        beforeSend: function() {
          $(elRow).find('button').prop('disabled', true);
          $(elRow).find('.fa-spin').show();
        },
        success: function(response) {
          appUi.uiToast(response.message, 'success');
        },
        error: function(response) {
          appUi.uiToast(response.message, 'error');
        },
        always: function() {
          $(elRow).find('button').prop('disabled', false);
          $(elRow).find('.fa-spin').hide();
        }
    }, 'Sending message...', appAjax.apiBaseUrl + '/pushnotif');
  };

  const onLoad = () => {
    console.log('About page loaded');

    var accessToken = localStorage.getItem(KEY_ACCESS_TOKEN);
    if (!accessToken) {
        return;
    }

    //-- Load user info
    appAjax._ajax_send(null, {
        type: 'GET',
        beforeSend: function() {
            setIsLoading(true);
        },
        success: function(response) {
            setUserData(response.data);
            loadUserSessions();
        },
        error: function(response) {
            setErrorMessage(response.message);
        },
        always: function() {
            setIsLoading(false);
        }
    }, 'Loading user info...', appAjax.apiBaseUrl + '/me');
  };

  useEffect(() => {
      if (!isInit) {
        onLoad();

        var windowHeight = $(window).height();
        $('#web_about_container').css('height', (windowHeight - 100) +'px');
      }

      isInit = true;
      
      return () => {
        console.log('About page unloaded');
      }
  }, []);

  return (
    <div className="container" style={{ paddingTop: '15px' }}>
      <div className="row">
        <div className="col-lg-8 offset-lg-2">
          <div className="card">
            <div className="card-header">
                <NavLink to="/"><i className="fa fa-chevron-left"></i> Back</NavLink>
                <span className="ml-3">
                    <i className="fa fa-question-circle"></i> <strong>About</strong>
                </span>
            </div>
            <div className="card-body" id="web_about_container" style={{ minHeight: '300px', overflowY: 'auto' }}>
                <p>React is a JavaScript library for building user interfaces.</p>
                {errorMessage && (
                    <div className="text-danger" role="alert">
                        <i className="fa fa-exclamation-triangle"></i> {errorMessage}
                    </div>
                )}

                {isLoading && (
                    <div>
                        <i className="fa fa-circle-notch fa-spin"></i> Loading user information...
                    </div>
                )}

                {userData && (
                    <div>
                        <h5>User Information</h5>
                        <p>Username: <code>{userData.username}</code></p>
                    </div>
                )}

                {isLoadingSessions && (
                    <div>
                        <i className="fa fa-circle-notch fa-spin"></i> Loading user sessions...
                    </div>
                )}

                {listSessions.length > 0 && (
                    <div className="table-responsive mt-1">
                        <table className="table table-bordered table-hover table-striped table-sm" style={{ fontSize: '14px' }}>
                            <thead>
                                <tr>
                                    <th>Device Name</th>
                                    <th>IP Address</th>
                                    <th style={{ width: '75px' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listSessions.map((session) => (
                                    <tr key={session.uuid} data-record-uuid={session.uuid}>
                                        <td>
                                            {session.device_name}
                                            <small className="d-block text-muted">Expired: {session.expired_at}</small>
                                        </td>
                                        <td>{session.ip_address}</td>
                                        <td>
                                            <button className="btn btn-secondary btn-sm" onClick={onClickSendMessage}>
                                                <i className="fa fa-paper-plane"></i>
                                                <i className="fa fa-circle-notch fa-spin ml-1" style={{ display: 'none' }}></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                <div className="mt-3">
                  <NavLink to="/"><i className="fa fa-home"></i> Home</NavLink>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
